import { constructPublicRoute } from '~/core/shared/utils/routing';

export const MIDDLE_OFFICE_SYSTEM_ROUTES = {
  notFound: constructPublicRoute('/404', 'Not found'),
} as const;
